
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"category"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"274"},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_listing_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"children"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url_key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"landing_page"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"best_sellers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"breadcrumb_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"breadcrumbs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_level"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_url_key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"breadcrumb_label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url_key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url_path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hero_banner_mobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hero_banner_desktop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hero_banner_desktop_size"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"height"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"meta_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"faq"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"landing_page"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":795}};
    doc.loc.source = {"body":"query category($id: Int = 274) {\n    category(id: $id) {\n        description\n        product_listing_description\n        children {\n            id\n            name\n            short_description\n            url_key\n            image\n            landing_page\n        }\n        best_sellers\n        breadcrumb_label\n        breadcrumbs {\n            category_id\n            category_name\n            category_level\n            category_url_key\n            breadcrumb_label\n        }\n        image\n        id\n        name\n        url_key\n        url_path\n        hero_banner_mobile\n        hero_banner_desktop\n        hero_banner_desktop_size {\n            width\n            height\n        }\n        meta_description\n        meta_title\n        meta_keywords\n        faq\n        landing_page\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["category"] = oneQuery(doc, "category");
        
